export default __webpack_public_path__ + "static/media/mobily-odb-logo.76dd6c28.svg";